var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 18.3332C5.39685 18.3332 1.66602 14.6023 1.66602 9.99984C1.66602 5.39734 5.39685 1.6665 9.99935 1.6665C14.6018 1.6665 18.3327 5.39734 18.3327 9.99984C18.3327 14.6023 14.6018 18.3332 9.99935 18.3332ZM9.99935 16.6665C11.7675 16.6665 13.4632 15.9641 14.7134 14.7139C15.9636 13.4636 16.666 11.7679 16.666 9.99984C16.666 8.23173 15.9636 6.53604 14.7134 5.28579C13.4632 4.03555 11.7675 3.33317 9.99935 3.33317C8.23124 3.33317 6.53555 4.03555 5.2853 5.28579C4.03506 6.53604 3.33268 8.23173 3.33268 9.99984C3.33268 11.7679 4.03506 13.4636 5.2853 14.7139C6.53555 15.9641 8.23124 16.6665 9.99935 16.6665ZM9.16852 13.3332L5.63268 9.79734L6.81102 8.619L9.16852 10.9765L13.8819 6.26234L15.061 7.44067L9.16852 13.3332Z",
    fill: "#505666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.ea0eaaf9c5f8609968f6f1c5e1a8662e.svg";
export { ForwardRef as ReactComponent };